import { AiseaApiFactory } from "@/api/aisea/apiFactory";

// 法人勤務種別リポジトリ
const enterpriseManningStatusRepository = AiseaApiFactory.get(
  "enterpriseManningStatus"
);

const MANNING_STATUS = {
  VESSEL: "VESSEL", // 乗船期間
  ASHORE: "ASHORE", // 陸上勤務期間
  OFF: "OFF", // 陸上休暇期間
  PAID_LEAVE: "PAID_LEAVE", // 有給休暇期間
  OTHER_OFF: "OTHER_OFF", // その他休暇期間
};

/**
 * 法人勤務種別サービス
 */
const EnterpriseManningStatusService = (() => {
  let _enterpriseManningStatuses = null;

  const fetch = async () => {
    const res = await enterpriseManningStatusRepository.fetch();
    if (!res || !res.status) {
      throw res;
    }
    _enterpriseManningStatuses = res.data;
    return _enterpriseManningStatuses;
  };

  const clear = () => {
    _enterpriseManningStatuses = null;
  };

  const findById = id => {
    if (!_enterpriseManningStatuses) {
      return null;
    }
    return _enterpriseManningStatuses.manning_statuses.find(
      status => status.id === id
    );
  };

  /**
   * セレクトボックスで選択可能な下船中様態一覧取得
   * @returns
   */
  const getSelectableAshoreStatuses = () => {
    if (!_enterpriseManningStatuses) {
      return [];
    }
    return _enterpriseManningStatuses.manning_statuses.filter(
      status =>
        status.is_selectable_in_manning_table &&
        status.type !== MANNING_STATUS.VESSEL
    );
  };

  return {
    MANNING_STATUS,
    fetch,
    clear,
    findById,
    getSelectableAshoreStatuses,
  };
})();

export default EnterpriseManningStatusService;
